import { createIconComponent } from '../../factory/create-icon-component';

export const USAIcon = createIconComponent(
  'USAIcon',
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4605_28264)">
      <path d="M22.9999 5H0.999878V20H22.9999V5Z" fill="#F0F0F0" />
      <path
        d="M22.9999 6.87482H0.999878V8.74964H22.9999V6.87482Z"
        fill="#D80027"
      />
      <path
        d="M22.9999 10.6249H0.999878V12.4997H22.9999V10.6249Z"
        fill="#D80027"
      />
      <path
        d="M22.9999 14.3745H0.999878V16.2493H22.9999V14.3745Z"
        fill="#D80027"
      />
      <path
        d="M22.9999 18.1246H0.999878V19.9995H22.9999V18.1246Z"
        fill="#D80027"
      />
      <path d="M11.9999 5H0.999878V13.0769H11.9999V5Z" fill="#2E52B2" />
      <path
        d="M5.28925 8.30872L5.11209 8.86611H4.53906L5.00274 9.21042L4.82558 9.76777L5.28925 9.42346L5.75263 9.76777L5.57551 9.21042L6.03919 8.86611H5.46611L5.28925 8.30872Z"
        fill="#F0F0F0"
      />
      <path
        d="M5.46611 10.8775L5.28925 10.3202L5.11209 10.8775H4.53906L5.00274 11.2219L4.82558 11.7792L5.28925 11.4349L5.75263 11.7792L5.57551 11.2219L6.03919 10.8775H5.46611Z"
        fill="#F0F0F0"
      />
      <path
        d="M3.04416 10.8775L2.86726 10.3202L2.6901 10.8775H2.11707L2.58074 11.2219L2.40358 11.7792L2.86726 11.4349L3.33067 11.7792L3.15356 11.2219L3.61715 10.8775H3.04416Z"
        fill="#F0F0F0"
      />
      <path
        d="M2.86726 8.30872L2.6901 8.86611H2.11707L2.58074 9.21042L2.40358 9.76777L2.86726 9.42346L3.33067 9.76777L3.15356 9.21042L3.61715 8.86611H3.04416L2.86726 8.30872Z"
        fill="#F0F0F0"
      />
      <path
        d="M5.28925 6.29724L5.11209 6.85468H4.53906L5.00274 7.19903L4.82558 7.75639L5.28925 7.41203L5.75263 7.75639L5.57551 7.19903L6.03919 6.85468H5.46611L5.28925 6.29724Z"
        fill="#F0F0F0"
      />
      <path
        d="M2.86726 6.29724L2.6901 6.85468H2.11707L2.58074 7.19903L2.40358 7.75639L2.86726 7.41203L3.33067 7.75639L3.15356 7.19903L3.61715 6.85468H3.04416L2.86726 6.29724Z"
        fill="#F0F0F0"
      />
      <path
        d="M7.71121 8.30872L7.53409 8.86611H6.96106L7.42469 9.21042L7.24762 9.76777L7.71121 9.42346L8.17467 9.76777L7.99751 9.21042L8.46118 8.86611H7.88815L7.71121 8.30872Z"
        fill="#F0F0F0"
      />
      <path
        d="M7.88815 10.8775L7.71121 10.3202L7.53409 10.8775H6.96106L7.42469 11.2219L7.24762 11.7792L7.71121 11.4349L8.17467 11.7792L7.99751 11.2219L8.46118 10.8775H7.88815Z"
        fill="#F0F0F0"
      />
      <path
        d="M10.3101 10.8775L10.1332 10.3202L9.95605 10.8775H9.38306L9.84665 11.2219L9.66953 11.7792L10.1332 11.4349L10.5966 11.7792L10.4195 11.2219L10.8831 10.8775H10.3101Z"
        fill="#F0F0F0"
      />
      <path
        d="M10.1332 8.30872L9.95605 8.86611H9.38306L9.84665 9.21042L9.66953 9.76777L10.1332 9.42346L10.5966 9.76777L10.4195 9.21042L10.8831 8.86611H10.3101L10.1332 8.30872Z"
        fill="#F0F0F0"
      />
      <path
        d="M7.71121 6.29724L7.53409 6.85468H6.96106L7.42469 7.19903L7.24762 7.75639L7.71121 7.41203L8.17467 7.75639L7.99751 7.19903L8.46118 6.85468H7.88815L7.71121 6.29724Z"
        fill="#F0F0F0"
      />
      <path
        d="M10.1332 6.29724L9.95605 6.85468H9.38306L9.84665 7.19903L9.66953 7.75639L10.1332 7.41203L10.5966 7.75639L10.4195 7.19903L10.8831 6.85468H10.3101L10.1332 6.29724Z"
        fill="#F0F0F0"
      />
    </g>
    <defs>
      <clipPath id="clip0_4605_28264">
        <rect x="1" y="5" width="22" height="15" rx="2" fill="white" />
      </clipPath>
    </defs>
  </svg>,
  'flag',
);
